<script setup>
import { computed } from 'vue'
import MixTableBlock from '@components/mix-table-block.v2'

const props = defineProps({
    searchResults: {
        type: Object,
        default: () => {},
    },
})

const mixes = computed(() => props.searchResults.Mixes)
</script>

<template>
    <div>
        <BaseSection
            v-if="mixes"
            padded
        >
            <MixTableBlock
                :mixes="mixes"
                genres
                is-indexed-list
            />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
